import React from "react";
import { Redirect, Route } from "react-router-dom";
import AuthService from "../services/AuthService";
import { hasAccess } from "../components/RolesModule/hasAccess";
import {
  MENU_ACCOUNTS,
  MENU_ACCOUNTS_WRITE,
  MENU_ACCOUNTS_ORGANIZATION,
  MENU_ACCOUNTS_ORGANIZATION_WRITE,
  MENU_ACCOUNTS_INDIVIDUAL,
  MENU_ACCOUNTS_INDIVIDUAL_WRITE,
  MENU_ADMIN_OFFERING,
  MENU_ADMIN_OFFERING_WRITE,
} from "../lib/const/permissions";
import { getCheckTenant } from "../services/utils/getCheckTenant";
import { getMainRedirectPath } from "./getMainRedirectPath";

const AccessForbidden = () => <h2>Доступ к разделу отсуствует</h2>;

const RouteWithSubRoutes = (route) => {
  const { routeProps } = route;
  const authenticated = !!AuthService.getCurrentUser();
  const checkTenant = getCheckTenant();

  const mainRedirectPath = getMainRedirectPath({
    isHasAccessOrganization: hasAccess(
      MENU_ACCOUNTS,
      MENU_ACCOUNTS_WRITE,
      MENU_ACCOUNTS_ORGANIZATION,
      MENU_ACCOUNTS_ORGANIZATION_WRITE
    ),
    isHasAccessIndividual: hasAccess(MENU_ACCOUNTS_INDIVIDUAL, MENU_ACCOUNTS_INDIVIDUAL_WRITE),
    isHasAccessOffering: hasAccess(MENU_ADMIN_OFFERING, MENU_ADMIN_OFFERING_WRITE),
  });

  return (
    <Route
      path={route.path}
      render={(props) => {
        if (route.redirect && authenticated)
          return (
            <>
              {route.component && (
                <route.component {...props} routes={route.routes} routeProps={routeProps} />
              )}
              <Redirect to={`${route.computedMatch.url}${route.redirect}`} />
            </>
          );

        if (route.private && authenticated && checkTenant) {
          // Проверяем оба условия: permissions (если есть) И permissionsDeep (если есть)
          const hasPermissions =
            !route.permissions ||
            (Array.isArray(route.permissions) && hasAccess(...route.permissions));

          const hasDeepPermissions =
            !route.permissionsDeep ||
            (Array.isArray(route.permissionsDeep) && hasAccess(...route.permissionsDeep));

          if (hasPermissions && hasDeepPermissions) {
            return (
              route.component && (
                <route.component {...props} routes={route.routes} routeProps={routeProps} />
              )
            );
          }
          return <AccessForbidden />;
        }

        if (route.private && !authenticated && route.path !== "/login") {
          return <Redirect to="/login" />;
        }
        if (!checkTenant && route.path !== "/login") {
          return <Redirect to="/login" />;
        }
        if (authenticated && route.path === "/login" && checkTenant) {
          return <Redirect to={mainRedirectPath} />;
        }

        if (authenticated && checkTenant) {
          // Проверяем оба условия: permissions (если есть) И permissionsDeep (если есть)
          const hasPermissions =
            !route.permissions ||
            (Array.isArray(route.permissions) && hasAccess(...route.permissions));

          const hasDeepPermissions =
            !route.permissionsDeep ||
            (Array.isArray(route.permissionsDeep) && hasAccess(...route.permissionsDeep));

          if (hasPermissions && hasDeepPermissions) {
            return (
              route.component && (
                <route.component {...props} routes={route.routes} routeProps={routeProps} />
              )
            );
          }
          return <AccessForbidden />;
        }

        return (
          route.component && (
            <route.component {...props} routes={route.routes} routeProps={routeProps} />
          )
        );
      }}
    />
  );
};

export default RouteWithSubRoutes;
